import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

import {EquipmentGraphicsDropdownComponent} from '../../components/DomainData/EquipmentGraphicsDropdown.component';

//constants
import { Constants }         from '../../constants/Constants';

//components
import {EquipmentsAutoCompleteComponent} from '../../components/Equipment/EquipmentsAutoComplete.component';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-equipmentlineitem-edit',
  templateUrl: './EquipmentLineItemEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => EquipmentLineItemEditComponent)}]
})
export class EquipmentLineItemEditComponent extends BaseEditComponent {

    public displayDialog: boolean;
    
    equipmentLineItemForm: FormGroup;

    @Input() public requireEquipmentGraphics: boolean;
    @Input() public requireEquipmentAssetNumber: boolean;
    @Input() public requireSerialNumber: boolean;
    @Input() public requireModel: boolean;
    @Input() public requireLocation: boolean;
    @Input() public requireCurrentLocation: boolean;
    @Input() public requireMoveToLocation: boolean;
    @Input() public requireNewCustomerNumber: boolean;

    @Input() public showEquipmentGraphics: boolean;
    @Input() public showEquipmentAssetNumber: boolean;
    @Input() public showSerialNumber: boolean;
    @Input() public showModel: boolean;
    @Input() public showLocation: boolean;
    @Input() public showCurrentLocation: boolean;
    @Input() public showMoveToLocation: boolean;
    @Input() public showNewCustomerNumber: boolean;
    
    
    @Input() public lineItem: ent.EquipmentLineItem;

    @ViewChild(EquipmentGraphicsDropdownComponent) public equipmentGraphicsDropdown: EquipmentGraphicsDropdownComponent;
    @ViewChild(EquipmentsAutoCompleteComponent) public equipmentsAutoCompleteComponent: EquipmentsAutoCompleteComponent;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder, private equipmentService: serv.EquipmentService) 
    { 
        super();
        let group = {
          'equipmentGraphics' : '',
          'hidEquipmentGraphics' : '',
          'equipmentAssetNumber' : '',
          'serialNumber' : '',
          'model' : '',
          'location' : '',
          'currentLocation' : '',
          'moveToLocation' : '',
          'newCustomerNumber' : ''
        };
        
        this.equipmentLineItemForm = fb.group(group);
        

    }

    ngOnInit(): void {
        if(this.requireEquipmentGraphics) {
            this.equipmentLineItemForm.controls['equipmentGraphics'].setValidators(dropDownValidator);
            this.equipmentLineItemForm.controls['hidEquipmentGraphics'].setValidators(hiddenDropDownValueValidator);
        }

        // if(this.requireEquipmentAssetNumber) {
        //     this.equipmentLineItemForm.controls['equipmentAssetNumber'].setValidators(Validators.required);
        // }

        if(this.requireSerialNumber) {
            this.equipmentLineItemForm.controls['serialNumber'].setValidators(Validators.required);
        }

        if(this.requireModel) {
            this.equipmentLineItemForm.controls['model'].setValidators(Validators.required);
        }

        if(this.requireLocation) {
            this.equipmentLineItemForm.controls['location'].setValidators(Validators.required);
        }

        if(this.requireCurrentLocation) {
            this.equipmentLineItemForm.controls['currentLocation'].setValidators(Validators.required);
        }

        if(this.requireMoveToLocation) {
            this.equipmentLineItemForm.controls['moveToLocation'].setValidators(Validators.required);
        }

        if(this.requireNewCustomerNumber) {
            this.equipmentLineItemForm.controls['newCustomerNumber'].setValidators(Validators.required);
        }
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.lineItem.EquipmentGraphicsID = this.equipmentGraphicsDropdown.selectedID;
       
        this.onOK.emit();
        
        this.displayDialog = false;

    }

    equipmentGraphicsSelected(){
        var val = true;
        var form = this.equipmentLineItemForm;
        if (form.controls.equipmentGraphics.errors && form.controls.hidEquipmentGraphics.errors){
            if (form.controls.equipmentGraphics.errors.invalid && form.controls.hidEquipmentGraphics.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    equipmentGraphicsChange(event: any){
        this.lineItem.EquipmentGraphicsID = event;
    }

    selectedEquipmentNumbersChanged(equipmentNumbers: string[]){
        if (equipmentNumbers && equipmentNumbers.length > 0){
            // var filter: filters.EquipmentFilter = {EquipmentNumber: equipmentNumbers[equipmentNumbers.length - 1]};
            // this.equipmentService.getEquipments(filter).then(x=>
            // {
            //     if (x && x.length > 0){
            //         this.lineItem.EquipmentAssetNumber = x[0].EquipmentNumber;
            //     }
            //     else{
            //         this.lineItem.EquipmentAssetNumber = "";
            //     }
                
            // });
        }
        else{
            this.lineItem.EquipmentAssetNumber = "";
        }

    }


}